
import React, { useContext, useEffect, useState } from 'react'
import ModalCover, { ModalCoverProps } from '../../modalCover/ModalCover'
import { RootState } from '../../../../core/store/store';
import { ActionBarOptions } from '../interfaces';
import { hideActionBar, resetCurrentPageActionBar } from '../actions/actionBar-action';
import { useDispatch, useSelector } from "react-redux";
import { useUser } from '../../../../core/hooks/db/user/useUser';
import { TableNamesType } from '../../../../core/interfaces/table-name-type';
import { AxiosResponse } from 'axios';
import { LoaderContext } from '../../../components/loader/context/LoaderContext';

import { useActionBarStore, useIdentityStore } from '../../../../core/store';
import { useTranslation } from 'react-i18next';
import { useBanner, useBlog, useProgram, useSponsor } from '../../../../core/hooks/db/fisioteduca/useFisioteduca';

interface DeleteModalProps {
    table: TableNamesType;
    items: any[],
    handleModalDelete: (value?: boolean) => void;


    // interface ModalCover
    count?: number;
    show?: any;
    children?: any;
    title?: any;
    hasCloseButton?: any;
    hasSuccessButton?: any;
    hasCloseHeaderButton?: any;

}

const DeleteModal = (props: DeleteModalProps) => {
    const { t } = useTranslation();
    const {
        table,
        handleModalDelete,
        items,

        // interface ModalCover
        count,
        show,
        children,
        title,
        hasCloseButton = true,
        hasSuccessButton = false,
        hasCloseHeaderButton = true,

    } = props;


    const { deleteUser } = useUser();
    const { deleteSponsor } = useSponsor();
    const { deleteBanner } = useBanner(); // Nuevo
    const { deleteBlog } = useBlog(); // Nuevo
    const { deleteProgram } = useProgram(); // Nuevo



    const { resetPageActionBar } = useActionBarStore(state => state)

    const dispatch = useDispatch();

    const [fnDelete, setFnDelete] =
        useState<(idList: string[] | number[], action: boolean) => Promise<AxiosResponse<any, any>> | null>(null);
    const [hasError, setHasError] = useState(false);
    const [labels, setLabels] = useState<{
        labelSigle: string,
        labelMany: string,
        titleModal: string
    }>({
        labelMany: "¿Quieres eliminar los registros elegidos?",
        labelSigle: "¿Quieres eliminar el registro elegidos?",
        titleModal: "Eliminar registro"
    });

    const { handleLoading } = useContext(LoaderContext);

    const { identity } = useIdentityStore(state => state)

    useEffect(() => {
        if (!fnDelete) {

            switch (table) {
                case 'sponsor':
                    setLabels({
                        labelMany: t('actionBar.modal.delete.sponsor.labelMany'),
                        labelSigle: t('actionBar.modal.delete.sponsor.labelSingle'),
                        titleModal: t('actionBar.modal.delete.sponsor.titleModal'),
                    });
                    setFnDelete(() => deleteSponsor);
                    break;
                case "banner":
                    setLabels({
                        labelMany: t("actionBar.modal.delete.banner.labelMany"),
                        labelSigle: t("actionBar.modal.delete.banner.labelSingle"),
                        titleModal: t("actionBar.modal.delete.banner.titleModal"),
                    });
                    setFnDelete(() => deleteBanner);
                    break;
                case "blog":
                    setLabels({
                        labelMany: t("actionBar.modal.delete.blog.labelMany"),
                        labelSigle: t("actionBar.modal.delete.blog.labelSingle"),
                        titleModal: t("actionBar.modal.delete.blog.titleModal"),
                    });
                    setFnDelete(() => deleteBlog);
                    break;
                case "program":
                    setLabels({
                        labelMany: t("actionBar.modal.delete.program.labelMany"),
                        labelSigle: t("actionBar.modal.delete.program.labelSingle"),
                        titleModal: t("actionBar.modal.delete.program.titleModal"),
                    });
                    setFnDelete(() => deleteProgram);
                    break;
                // case 'categories':
                //     setLabels({
                //         labelMany: t('actionBar.modal.delete.category.labelMany'),
                //         labelSigle: t('actionBar.modal.delete.category.labelSingle'),
                //         titleModal: t('actionBar.modal.delete.category.titleModal'),
                //     });
                //     // setFnDelete(() => deleteCategory);
                //     break;
                // case 'services':
                //     setLabels({
                //         labelMany: t('actionBar.modal.delete.service.labelMany'),
                //         labelSigle: t('actionBar.modal.delete.service.labelSingle'),
                //         titleModal: t('actionBar.modal.delete.service.titleModal'),
                //     });
                //     // setFnDelete(() => deleteService);
                //     break;
                default:
                    setHasError(true);
                    console.error('Mal uso del modal DELETE. Tabla recibida', table);
            }

        }
    }, [table]);


    const successButton = async () => {

        try {
            handleLoading(true);

            // console.log("[Modal Delete] - items is...", items);
            // console.log("[Modal Delete] - items is...", items);
            // console.log("[Modal Delete] - items is...", items);
            // console.log("[Modal Delete] - items is...", items);

            // return;
            let result = await fnDelete(items, true);
            console.log("[Modal Delete] - result is...", result)
        } catch (e) {
            console.error(e)
        } finally {
            handleModalDelete(false);
            setTimeout(() => {
                resetPageActionBar();
                dispatch(resetCurrentPageActionBar());
            }, 100)
        }
    }

    return (
        <ModalCover
            styleHeader={{ fontSize: '1.5rem' }}

            show={!hasError ? show : false}

            title={labels.titleModal}
            hasCloseButton={true}
            hasSuccessButton={true}

            handleModal={handleModalDelete}
            fnSuccess={successButton}
        >
            <div>
                {count > 1
                    ? (
                        <span>{labels.labelMany}</span>
                    )
                    : (
                        <span>{labels.labelSigle}</span>
                    )
                }
            </div>
        </ModalCover>
    )
}

export default DeleteModal

